// resources/js/composables/useHover.ts
import { ref, watch, onBeforeUnmount, Ref } from 'vue';

export function useHover(
    target: Ref<HTMLElement | null>,
    onMouseOver?: () => void,
    onMouseOut?: () => void
) {
    const isHovered = ref(false);
    let cleanup = () => {};

    const register = (el: HTMLElement | null) => {
        // remove old listeners
        cleanup();

        if (!el) return;

        const handleMouseOver = () => {
            isHovered.value = true;
            onMouseOver?.();
        };
        const handleMouseOut = () => {
            isHovered.value = false;
            onMouseOut?.();
        };

        el.addEventListener('mouseover', handleMouseOver);
        el.addEventListener('mouseout', handleMouseOut);

        cleanup = () => {
            el.removeEventListener('mouseover', handleMouseOver);
            el.removeEventListener('mouseout', handleMouseOut);
        };
    };

    // watch for the ref to be set / change
    watch(target, register, { immediate: true });

    // clean up on unmount
    onBeforeUnmount(() => cleanup());

    return { isHovered };
}
